$(document).ready( function(){

	if($('.slider').length > 0){

		var slider = $('.slider');
		var slider_nav_trigger = slider.find('.trigger');

	    slider_nav_trigger.click( function(){
	    	var current_slide = slider.find('.slide.current');

	    	// figure out which is the next slide,
	    	// depending on whether we're using the nav buttons
	    	// or the prev/next arrows
	    	if($(this).hasClass('prev')){
	    		if(current_slide.prev('.slide').length){
		    		var next_slide = current_slide.prev('.slide');
		    	}else{
		    		var next_slide = slider.find('.slide').last();
		    	}
	    	}
	    	else if($(this).hasClass('next')){
	    		if(current_slide.next('.slide').length){
		    		var next_slide = current_slide.next('.slide');
		    	}else{
		    		var next_slide = slider.find('.slide').first();
		    	}
	    	}
	    	else{
	    		var next_slide = slider.find('#' + $(this).data('slide'));
	    	}
	    	
	    	// update slides
	    	ChangeBannerSlide(current_slide,next_slide);

	    });

	    function ChangeBannerSlide(current_slide,next_slide){
	    	current_slide.removeClass('current');
	    	current_slide.addClass('old');
	    	setTimeout(
	    		function(){
	    			current_slide.removeClass('old');
	    		},
	    		200
	    	);
	    	next_slide.addClass('current');
	    	slider.find('.slide').removeClass('next');
	    	if(next_slide.next('.slide').length){
	    		var in_the_wings = next_slide.next('.slide');
	    	}else{
	    		var in_the_wings = slider.find('.slide').first();
	    	}
	    	in_the_wings.addClass('next');

	    	// update nav
	    	slider_nav_trigger.removeClass('current');
	    	$('.slider .trigger[data-slide="' + next_slide.attr('id') + '"]').addClass('current'); 
	    }

	}
});